module.exports = __webpack_public_path__ + "static/how-it-works-3-c398e7158a1988515b3348779e8fe4d3.png";